const AttachmentStyle = () => ({
  attachment: {
    width: 217,
    height: 40,
    borderRadius: 8,
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: '#E2E8EB',
    display: 'flex',
    alignItems: 'center',
    padding: '5px 5px',
    textAlign: 'start',
    cursor: 'pointer',
    transition: 'border-color 0.2s ease, background-color 0.2s ease',
  },
  active: {
    backgroundColor: 'rgba(0, 168, 188, 0.12)',
    borderColor: '#00A8BC',
  },
  inactive: {
    backgroundColor: '#fff',
    '&:hover': {
      borderColor: 'rgba(0, 168, 188, 0.4)',
    },
  },
  fileIcon: {
    margin: '0 10px 0 5px',
    color: '#fff',
    width: 30,
    height: 35,
  },
  fileName: {
    fontSize: 13,
    color: '#6B7780',
    width: 250,
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
  },
  fileSize: {
    fontSize: 10,
    color: '#6B7780',
  },
  downloadIcon: {
    marginRight: 10,
    color: '#00A8BC',
    cursor: 'pointer',
    width: 25,
    height: 25,
  },
});

export default AttachmentStyle;
